
import '../apply-rule-modal.css';

import React, { useState } from 'react';
import { CQAppConstant } from '../../../../../app-constants';
import { observer } from 'mobx-react';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { IToggleRuleModalState, ICriteria, IToggleActionsRuleModalProps, ICoreRule, IExtendedRule } from '../../ILayoutConfigurationPanel.Interface';
import LayoutFieldsConfigController from '../../../layout-level-fields.controller';
import { CommonRuleModal } from '../common-rule-modal';
import { useEffect } from 'react';

const INITIAL_STATE = {
    field: '',
    operator: '',
    compareTo: '',
    isDynamic: false,
    selectedFieldType: '',
    referenceField: '',
    referenceTo: '',
    relationshipName:''
}

const layoutFieldsConfigCtrl = new LayoutFieldsConfigController();

const ToggleActionsRulesModalComponent = (props: IToggleActionsRuleModalProps) => {
    const [state, setState] = useState<ICoreRule>(() => ({
        addedCriterias: [INITIAL_STATE],
        complexLogicQuery: '1',
        complexLogicVisibility: false,
        shouldSkip: false
    }));

    const [extraState, setExtraState] = useState<IExtendedRule>(() => ({
        additionalFields: [],
        fieldWisePicklistValues: [],
        selectedReferenceFields: [],
    }));

    const [shouldValidate, setShouldValidate] = useState(false);

    useEffect(() => {
        (async () => {
            if(!props.appliedRule) {
                return;
            }

            const ruleObject = CQMasterDataStore.RuleElements.FieldRuleElement;
            const objName = props.objectName;
            const ruleElement = { ...(ruleObject[objName!])[props.appliedRule] };

            if(!ruleElement) {
                return;
            }
            
            const selectedObjectName = CQMasterDataStore.OutputConfig.getStoreKeyData(props.selectedTemplateName, 'selectedObject');
            let selectedReferenceFields: any[] | undefined = [];
            let fieldWisePicklistValues = ruleElement.fieldWisePicklistValues;
            if (ruleElement.selectedReferenceFields) {
                selectedReferenceFields = await layoutFieldsConfigCtrl.getLookFieldsDataInEditMode(ruleElement.selectedReferenceFields);
                selectedReferenceFields = (selectedReferenceFields && selectedReferenceFields.length > 0) ? selectedReferenceFields : [];
            }


            if(ruleElement.fieldWisePicklistValues){
                fieldWisePicklistValues = await layoutFieldsConfigCtrl.getPickListValueDataInEditMode(selectedObjectName,ruleElement.fieldWisePicklistValues);
                fieldWisePicklistValues = (fieldWisePicklistValues && fieldWisePicklistValues.length > 0) ? fieldWisePicklistValues : [];
            }
            props.setRuleObject(ruleElement);
            setState({
                addedCriterias: ruleElement.addedCriterias,
                complexLogicQuery: ruleElement.hasOwnProperty('complexLogicQuery') ? ruleElement.complexLogicQuery : '',
                complexLogicVisibility: ruleElement.complexLogicVisibility,
                shouldSkip: ruleElement.shouldSkip
            });
            
            setExtraState({
                selectedReferenceFields,
                fieldWisePicklistValues,
                additionalFields: ruleElement.additionalFields
            });

        })()

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        updateRuleObject(CQAppConstant.ADDED_CRITERIAS, generateMergedStore());
        props.checkValidation(validateAddRuleForm());

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    useEffect(() => {
        updateRuleObject(CQAppConstant.ADDED_CRITERIAS, generateMergedStore());

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [extraState]);

    function generateMergedStore(): IToggleRuleModalState {
        return {...state, ...extraState};
    }

    /**
     * @description updates rule object and checks for validation for rule
     * @memberof ToggleActionsRulesModalComponent
     */
    function updateRuleObject(ruleObjectProperty: string, ruleObjectValue: any) {
        props.setRuleObject(ruleObjectValue);
        props.checkValidation(validateAddRuleForm());
    }
    /**
     * @description Used for validation for rule added for field type
     * @returns {boolean} If state are valid then returns false else true
     * @memberof ToggleActionsRulesModalComponent
     */
    function validateAddRuleForm() {
        if (!shouldValidate) {
            return true;
        } 

        let isCriteriaValid = state.addedCriterias.every((criteria: ICriteria, index: number) =>
            (criteria.field !== ''
                && criteria.operator !== ''
                && ((criteria.operator === CQAppConstant.EXISTS || criteria.operator === CQAppConstant.ISEMPTY) ? true : (criteria.compareTo !== ''))
                && (( CQAppConstant.REFERENCE_FIELD_TYPE).includes(criteria.selectedFieldType)?
                 ((criteria.operator === CQAppConstant.EXISTS || criteria.operator === CQAppConstant.ISEMPTY || index === 0) ? true :
                 (criteria.referenceField !== '')) : true)
            ));

        if (state.shouldSkip) {
            isCriteriaValid = true;
        }

        if (!isCriteriaValid || state.complexLogicQuery === '') {
            return true;
        }
        return false;
    }

    /**
     * @description Used to set validation true for new states
     * @param newState contains state copy
     */
    function updateState (newState: ICoreRule) {
        if (!shouldValidate) {
            setShouldValidate(true);
        }
        setState(newState);
    }

    var counts:Array<number> = []; // to store the length of additional fields.
    return (
        <>
            <div className="slds-grid slds-grid_vertical">
                <CommonRuleModal
                    modalInfo= {{
                        shouldRenderAddComplexBtn: true,
                        shouldDisableFirstElement: false,
                        toggleModalVisibility: props.toggleModalVisibility
                    }}
                    parentAction= {{
                        updateState: (state: ICoreRule) => updateState(state),
                        updateExtraState: function(state: IExtendedRule){
                            if(props.selectedTemplateName !== "cqNBA" && (state.fieldWisePicklistValues.length > 0 || state.selectedReferenceFields.length>0 )){
                                setExtraState(state);   
                            }
                            if(state.additionalFields.length !== 0 ) {
                                counts.push(state.additionalFields.length);

                                /* [Math.max.apply(0, times)] Set its maximum value at 0th index */
                                if (state.additionalFields.length === Math.max.apply(0, counts)){
                                    setExtraState(state);  // only updates the state if maximum length of array is reached.
                                }
                            }
                        }
                    }}
                    parentInfo= {{
                        state,
                        extraState,
                        initialCriteria: INITIAL_STATE,
                        addFieldOnSkip: true
                    }}
                    objectName= {props.objectName}
                    templateName= {props.selectedTemplateName}
                />
            </div>
        </>
    );
}
export const ToggleActionRulesModal = observer(ToggleActionsRulesModalComponent);
